// extracted by mini-css-extract-plugin
module.exports = {"sideBarLoader":"SideBarLoader_sideBarLoader__2xYdP"};